/**
 * @file Postgresql.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2020
 */

import Service from './Service'

/**
 * Postgresql Management Service
 * @class
 */
class Postgresql extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
  }
}

export { Postgresql }
